import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { DateTimePickerProps } from "@mui/x-date-pickers/DateTimePicker/DateTimePicker.types";

export default function DateTimePicker<
  TEnableAccessibleFieldDOMStructure extends boolean = false,
>(props: DateTimePickerProps<TEnableAccessibleFieldDOMStructure>) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDateTimePicker
        ampmInClock={false}
        ampm={false}
        format={"DD.MM.YY HH:mm"}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        }}
        {...props}
      />
    </LocalizationProvider>
  );
}
